/**
 * German texts of the setup assistant (F-72): the overview with the progress and one page per
 * step. Spread into the German dictionary, so they are part of {@link MessageKey}.
 */
export const setupWizardMessagesDe = {
  "setupWizard.steps": "Schritte der Einrichtung",
  "setupWizard.progressLabel": "Fortschritt der Einrichtung",
  "setupWizard.progressValue": "{done} von {total} Schritten erledigt",
  "setupWizard.start": "Einrichtung beginnen",
  "setupWizard.continueWith": "Weiter mit „{step}“",
  "setupWizard.allDone":
    "Alle Schritte sind erledigt. Sie können jeden Schritt weiterhin öffnen und ändern.",
  "setupWizard.freeOrder":
    "Die Reihenfolge ist ein Vorschlag. Sie können jeden Schritt jederzeit öffnen und später fortsetzen.",
  "setupWizard.state.done": "Erledigt",
  "setupWizard.state.started": "Begonnen",
  "setupWizard.state.open": "Offen",
  "setupWizard.state.unreported": "Ohne Stand",
  "setupWizard.allCountedDone":
    "Alle Schritte mit Stand sind erledigt. Sie können jeden Schritt weiterhin öffnen und ändern.",
  "setupWizard.unreportedHint":
    "Zu Schritten „Ohne Stand“ liegt noch keine Angabe vor. Sie zählen nicht zum Fortschritt; Sie können sie trotzdem öffnen und bearbeiten.",
  "setupWizard.unreportedStep":
    "Zu diesem Schritt liegt noch keine Angabe vor. Er zählt nicht zum Fortschritt; Sie können ihn trotzdem bearbeiten.",
  "setupWizard.position": "Schritt {number} von {total}",
  "setupWizard.items": "Stand dieses Schritts",
  "setupWizard.navigation": "Zwischen den Schritten wechseln",
  "setupWizard.back": "Zurück",
  "setupWizard.backNamed": "Zurück zu „{step}“",
  "setupWizard.next": "Weiter",
  "setupWizard.nextNamed": "Weiter zu „{step}“",
  "setupWizard.overview": "Zur Übersicht",
  "setupWizard.later": "Später erledigen",
  "setupWizard.laterNamed": "„{step}“ später erledigen",
  "setupWizard.laterAnnounced":
    "„{step}“ bleibt offen. Sie finden den Schritt in der Übersicht der Einrichtung.",
  "setupWizard.step.establishment.title": "Betrieb und Sonderregeln",
  "setupWizard.step.establishment.summary":
    "Prüfen Sie Bundesland, Branchen und Sonntagsausnahme jedes Betriebs und ob besondere Regelungen für Ihren Betrieb gelten.",
  "setupWizard.step.work-time-models.title": "Arbeitszeitmodelle",
  "setupWizard.step.work-time-models.summary":
    "Legen Sie Modelle aus Vorlagen an und prüfen Sie Sollstunden und Arbeitstage in der Verwaltung.",
  "setupWizard.step.information.title": "Betriebsrat und Information",
  "setupWizard.step.information.summary":
    "Beteiligen Sie den Betriebsrat, falls es einen gibt, und informieren Sie die Beschäftigten über die Verarbeitung ihrer Daten. Beides bestätigen Sie hier.",
  "setupWizard.step.employees.title": "Beschäftigte",
  "setupWizard.step.employees.summary":
    "Legen Sie die Beschäftigten aus einer CSV-Datei oder einzeln an. Der Schritt ist erledigt, sobald außer Ihnen weitere Beschäftigte angelegt sind.",
  "setupWizard.step.leave.title": "Urlaubsregeln und Urlaubsstände",
  "setupWizard.step.leave.summary":
    "Legen Sie unter „Mandant“ die Urlaubsregeln fest; ohne sie gibt es keine Urlaubskonten. Resturlaub aus dem Vorsystem übernehmen Sie hier.",
  "setupWizard.step.invitations.title": "Einladungen und erste Stempelung",
  "setupWizard.step.invitations.summary":
    "Senden Sie die Einladungen; danach legen die Beschäftigten ihr Passwort fest und können stempeln. Mit der ersten Stempelung ist der Schritt erledigt.",
} as const satisfies Record<string, string>;
